import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
const articles = [{
  title: 'Trends in ancillary cost containment for 2026',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90',
  date: 'May 12, 2026',
  readTime: '5 min read',
  category: 'Cost Containment'
}, {
  title: 'How AI is reshaping claims triage and early intervention',
  image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90',
  date: 'April 28, 2026',
  readTime: '4 min read',
  category: 'Technology'
}, {
  title: 'Reducing claim duration with proactive field case management',
  image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=90',
  date: 'April 15, 2026',
  readTime: '6 min read',
  category: 'Clinical'
}];
export function Insights() {
  return <section id="insights" className="py-24 bg-brand-paper" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-228">
          <div className="max-w-2xl" data-id="element-229">
            <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-230">
              Resources
            </h2>
            <h3 className="text-4xl font-serif text-brand-navy" data-id="element-231">
              Latest Insights
            </h3>
          </div>
          <a href="#" className="hidden md:inline-flex items-center text-brand-navy font-semibold hover:text-brand-gold transition-colors" data-id="element-232">
            View all articles <ArrowRight className="w-4 h-4 ml-2" data-id="element-233" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-234">
          {articles.map((article, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 group cursor-pointer border border-gray-100" data-id="element-235">
              <div className="relative h-48 overflow-hidden" data-id="element-236">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-237" />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded text-xs font-bold text-brand-navy uppercase tracking-wide" data-id="element-238">
                  {article.category}
                </div>
              </div>
              <div className="p-6" data-id="element-239">
                <div className="flex items-center text-xs text-gray-500 mb-3 space-x-4" data-id="element-240">
                  <span data-id="element-241">{article.date}</span>
                  <span className="flex items-center" data-id="element-242">
                    <Clock className="w-3 h-3 mr-1" data-id="element-243" /> {article.readTime}
                  </span>
                </div>
                <h4 className="text-xl font-serif font-bold text-brand-navy mb-4 group-hover:text-brand-gold transition-colors leading-snug" data-id="element-244">
                  {article.title}
                </h4>
                <div className="text-brand-navy font-medium text-sm flex items-center" data-id="element-245">
                  Read article{' '}
                  <ArrowRight className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" data-id="element-246" />
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-247">
          <a href="#" className="inline-flex items-center text-brand-navy font-semibold hover:text-brand-gold transition-colors" data-id="element-248">
            View all articles <ArrowRight className="w-4 h-4 ml-2" data-id="element-249" />
          </a>
        </div>
      </div>
    </section>;
}